module.exports = __webpack_public_path__ + "media/images/ac_templates/201/clpht-6b6066d0ca63174c559023a2e87463cf.jpg";